import React from "react";

export default function TranslationProcess({backgroundCol}) {
  return (
    <div className={`${backgroundCol ? backgroundCol :"bg-darkBlue "}  flex items-center justify-center`}>
      <div className="mainDiv lg:w-7/12 w-full text-white flex-col flex items-center  justify-center py-28 max-w-screen-xl">
        <h2 className="text-center text-4xl font-bold font-secondary">
          The Website Translation Process
        </h2>
        <p className="text-center font-light py-16 leading-8 font-opensans">
          After thousands of successful engagements, Tomedes has a proven
          formula and best-practice process for website translation to ensure
          optimal results.
        </p>
        <div className="upperDiv flex  xl:justify-between justify-center w-full flex-wrap xl:flex-nowrap">
        <div className="primeDiv flex items-center relative flex-col  mb-14 xl:mb-0">
          <div>
          <h3 class="rounded-full text-center bg-lightBlue h-16 w-16 flex items-center justify-center mx-auto">
              1.
            </h3>
          </div>
          <span className="border-b-2 border-lightBlue 2xl:w-72 xl:w-44 xl:inline-block hidden   ml-4 absolute top-[30px] left-[70%]"></span>
            <h3 className="mt-10 text text-2xl font-semibold text-center text-secondary">
              UI Content Extraction
            </h3>
          </div>
          <div className="primeDiv flex items-center relative flex-col   mb-14 xl:mb-0">
          <div>
          <h3 class="rounded-full text-center bg-lightBlue h-16 w-16 flex items-center justify-center mx-auto">
              2.
            </h3>
           
          </div>
          <span className="border-b-2 border-lightBlue 2xl:w-72 xl:w-44 xl:inline-block hidden  ml-4 absolute top-[30px] left-[65%]"></span>
            <h3 className="mt-10 text text-2xl font-semibold text-center text-secondary">
            Linguistic and Functionality <br/> Quality Check
            </h3>
          </div>
          <div className="primeDiv flex items-center relative flex-col  mb-14 xl:mb-0">
          <div>
          <h3 class="rounded-full text-center bg-lightBlue h-16 w-16 flex items-center justify-center mx-auto">
              3.
            </h3>
           
          </div>
          <span className="border-b-2 hidden border-lightBlue w-72 ml-4 absolute top-[30px] left-[60%]"></span>
            <h3 className="mt-10 text text-2xl font-semibold text-center text-secondary">
            Project Management
            </h3>
          </div>
          
        </div>
        <div className="flex items-center xl:justify-between justify-center md:gap-3 xl:gap-0 lg:w-7/12 w-full lg:my-20  flex-wrap xl:flex-nowrap">
        <div className="primeDiv flex items-center relative flex-col mb-14 xl:mb-0">
          <div>
          <h3 class="rounded-full text-center bg-lightBlue h-16 w-16 flex items-center justify-center mx-auto">
              4.
            </h3>
          </div>
          <span className="border-b-2 border-lightBlue 2xl:w-72 xl:w-44 xl:inline-block hidden ml-4 absolute top-[30px] left-[70%]"></span>
            <h3 className="mt-10 text text-2xl font-semibold text-center text-secondary">
            Source Validation
            </h3>
          </div>
          <div className="primeDiv flex items-center  flex-col  mb-14 xl:mb-0">
          <div>
          <h3 class="rounded-full text-center bg-lightBlue h-16 w-16 flex items-center justify-center mx-auto">
              5.
            </h3>
          </div>
        
            <h3 className="mt-10 text text-2xl font-semibold text-center text-secondary">
            QA and Linguistic QA
            </h3>
          </div>
        </div>
        <div className="lowerDiv"></div>
      </div>
    </div>
  );
}
